import styled from 'styled-components';

import { gridSizes, weights } from 'utils/style';

import Tips from 'components/RecurringOrderSuggestionsModal/Sections/Tips/component';

export default styled(Tips)`
  & {
    margin-top: ${gridSizes('M')};
  }

  p {
    color: var(--grey900);
    font-size: 16px;
    line-height: 21px;
    font-weight: ${weights('medium')};
    text-align: center;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    line-height: 24px;
    font-size: 16px;
    font-weight: ${weights('normal')};
    color: var(--grey700);
    padding: 4px 0;
  }

  .checkIconWrapper {
    margin-right: 30px;
    margin-left: 4px;
  }
`;
